import styled, { css } from 'styled-components';

const sizingStyles = css`
  ${({ $size }) =>
    `max-width: ${
      $size === 'Small' ? '578px' : $size === 'Medium' ? '784px' : $size === 'Large' ? '990px' : ''
    };`}
`;

const WistiaWrapper = styled.div`
  height: 100%;
  width: ${({ $label }) => ($label ? 'auto' : '100%')};
  ${({ $size }) => $size && sizingStyles}

  .wistia-video--wrapper {
    position: relative;

    &:has(.cta-text-link) {
      position: inherit;
    }

    .w-vulcan-overlays-table {
      display: none !important;
    }

    .w-big-play-button {
      display: none !important;
    }
  }
`;

const hideDefaultThumbnail = css`
  .wistia_click_to_play img,
  .w-video-wrapper img {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
`;

export { hideDefaultThumbnail, WistiaWrapper };
